//ClientName & ClientNameCheck
export const UPDATE_NAME = "UPDATE_NAME";
//DrinkOptionsDialog
export const ADD_DRINK_TO_ORDER = "ADD_DRINK_TO_ORDER";
//MenuSummaryLayout
export const REMOVE_DRINK_FROM_ORDER = "REMOVE_DRINK_FROM_ORDER";
//ClientNameCheck
export const CLIENT_MEETING_LOCATION = "CLIENT_MEETING_LOCATION";
export const CLIENT_MEETING_TYPE = "CLIENT_MEETING_TYPE";
//BottomNavBar
export const SET_MENU_ALERT = "SET_MENU_ALERT";
//SnackBarAlert & DrinkOptionsDialog
export const SET_SNACKBAR_ALERT = "SET_SNACKBAR_ALERT";
//Menu from server API??
export const UPDATE_MENU = "UPDATE_MENU";
//Menu Summary
export const UPDATE_COMMENTS = "UPDATE_COMMENTS";
//clear order
export const CLEAR_ORDER = "CLEAR_ORDER";
//clear comments
export const CLEAR_COMMENTS = "CLEAR_COMMENTS";
//Meeting date
export const CLIENT_MEETING_DATE = "CLIENT_MEETING_DATE"


